import React, { useEffect } from 'react';
import { msalInstance } from '../service/msal';
import { EventMessage, EventType, AuthenticationResult } from '@azure/msal-browser';

const AuthenticationHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  useEffect(() => {
    const callbackId = msalInstance.addEventCallback((event: EventMessage) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload &&
        (event.payload as AuthenticationResult).account
      ) {
        const account = (event.payload as AuthenticationResult).account!;
        msalInstance.setActiveAccount(account);
      }
    });

    return () => {
      if (callbackId) {
        msalInstance.removeEventCallback(callbackId);
      }
    };
  }, []);

  return <>{children}</>;
};

export default AuthenticationHandler;
